/** Status values accepted by validation request updates. */
export const VALIDATION_REQUEST_STATUSES = [
  'pending',
  'acknowledged',
  'fulfilled',
  'declined',
] as const

export type ValidationRequestStatus = typeof VALIDATION_REQUEST_STATUSES[number]

/** Guard for API and demo handlers that accept a request status from JSON. */
export function isValidationRequestStatus(value: unknown): value is ValidationRequestStatus {
  return typeof value === 'string' &&
    (VALIDATION_REQUEST_STATUSES as readonly string[]).includes(value)
}

/** Persisted validation request returned by /api/validations/requests. */
export interface ValidationRequestRecord {
  id: string
  /** Missing only on records written before client scoping was introduced. */
  clientId?: string | null
  tenantId: string
  requestedByEmail?: string
  requestedByName?: string
  message?: string
  /**
   * The program the tenant asked about: its stable identity (`validationId`,
   * or the code on a record written before 0032 gave it one). ABSENT on an
   * unscoped "more validations" ask, which names no program, and on every
   * request written before program scoping. Absent is "they did not say", never
   * "every program".
   */
  programId?: string
  /** The program's name when the request was made, for display after a rename or deletion. */
  programName?: string
  status: ValidationRequestStatus
  requestedAt: string
  updatedAt: string
}

export interface ValidationRequestListResponse {
  requests: ValidationRequestRecord[]
}

export interface ValidationRequestMutationResponse {
  request: ValidationRequestRecord
}
